<template lang="pug">
  span.title-content(:class="{'required-text': required}")
    span.required(v-if="required") *
    .truncate-container(v-if="isPresent(preparedText)")
      div(v-if="cut_text && preparedText.length > length+4")
        .truncated-text(v-if="!reading_more")
          span(v-html="meth_truncate(preparedText)")
          a.read-more-link(@click.prevent="reading_more=true") {{t('app.shared.show_more')}}
        .full-text(v-else)
          div(v-html="$sanitize(preparedText)" v-linkified="")
          a.read-more-link(@click.prevent="reading_more=false") {{t('app.shared.show_less')}}

      div(v-else v-html="$sanitize(preparedText)" v-linkified="")
</template>

<script>
  import helpers from 'code/base_mixins'

  const TRUNCATION_LENGTH = 94;
  export default {
    name: "with_required",
    mixins: [helpers],
    props: {
      required: {
        type: Boolean,
        default: false,
      },
      text: {
        type: String,
        default: null,
      },
      cut_text: {
        type: Boolean,
        default: false,
      },
      truncate: {
        type: Boolean,
        default: false
      },
      length: {
        type: Number,
        default: TRUNCATION_LENGTH
      },
      initial_reading_more: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        reading_more: false
      }
    },
    created() {
      this.reading_more = this.initial_reading_more
    },
    methods: {
      meth_truncate(txt) {
        const txt2 = this.$sanitize(txt)
        let length = this.length;
        let mark_pos = txt2.indexOf("<");
        if (mark_pos > 0 && mark_pos < length) length = mark_pos
        // if (length === 0) length = TRUNCATION_LENGTH
        // if (txt.length <= length)   return txt
        if (txt2.length <= length+4) return txt2

        return txt2.substring(0, length) + " ... "
      }
    },
    computed: {
      preparedText() {
        let local_text = this.text;
        if (this.isPresent(local_text)) local_text = this.to_br(local_text)
        if (this.isBlank(local_text) && this.required) local_text = this.t('app.program.addon.required')

        return local_text
      },
    },
  }
</script>
